import React from "react";
import ReactMarkdown from "react-markdown";
import { useTranslation } from "react-i18next";

import { Banner } from "fe-shared/src/components";
import convertMinutes from "../../../helpers/convertMinutes";
import { Transaction } from "../../../types";
import styles from "../DetailsDataSection.module.scss";

interface Props {
  transaction: Transaction;
}

const NonEligibleBalanceBanners = ({ transaction }: Props) => {
  const { t } = useTranslation();
  const {
    transactionType,
    estimatedNonEligibleBuffer,
    bufferAllocationPeriodDurationInMinutes,
  } = transaction;

  const isExpired = !bufferAllocationPeriodDurationInMinutes;

  if (
    estimatedNonEligibleBuffer === null ||
    estimatedNonEligibleBuffer === undefined
  ) {
    return null;
  }

  return (
    <>
      {isExpired ? (
        <Banner
          id="non-eligible-buffer-counter-expired"
          variant="info"
          title={t(
            "transactions.details.nonEligibleBufferCounterExpired.title"
          )}
          className={styles.estimatedBufferBalanceBannerWrapper}
        >
          <ReactMarkdown
            source={t(
              `transactions.details.nonEligibleBufferCounterExpired.info.${transactionType}`
            ).toString()}
          />
        </Banner>
      ) : (
        <>
          <Banner
            id="non-eligible-estimated-balance-banner"
            variant="info"
            title={t("transactions.details.estimatedBufferBalanceBanner.title")}
          >
            <div className={styles.estimatedBufferBalanceBanner}>
              <span className={styles.estimatedBufferBalanceBannerInfo}>
                {t("transactions.details.estimatedBufferBalanceBanner.info")}
              </span>
              <div className={styles.estimatedBufferBalanceBannerData}>
                <div>
                  {t(
                    `transactions.details.estimatedBufferBalanceBanner.dataLabel.${transactionType}`
                  )}
                </div>
                <div>{estimatedNonEligibleBuffer || 0}</div>
              </div>
            </div>
          </Banner>
          <Banner
            id="non-eligible-buffer-counter"
            variant="info"
            title={t("transactions.details.nonEligibleBufferCounter.title", {
              days:
                convertMinutes(bufferAllocationPeriodDurationInMinutes).days +
                1,
            })}
            className={styles.estimatedBufferBalanceBannerWrapper}
          >
            <ReactMarkdown
              source={t(
                "transactions.details.nonEligibleBufferCounter.info"
              ).toString()}
            />
          </Banner>
        </>
      )}
    </>
  );
};

export default NonEligibleBalanceBanners;
